import DealNameSelect from './DealNameSelect';

export default DealNameSelect;
